import * as jQuery from "jquery";
import * as Handlebars from "handlebars";
import { zfTranslations } from "./zf_translations";
const $ = jQuery;
export class zfcsr {
    static selectorAttributeValue(value) {
        return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    }
    static get(key, lang) {
        var _a;
        if (lang == undefined)
            lang = ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang) || "en";
        var region = "";
        var langObj = zfcsr.regions[key];
        if (langObj != undefined) {
            region = langObj[lang];
            if (region == undefined || region == "" || region == "null") {
                if (langObj["en"] != undefined)
                    region = langObj["en"];
                else if (langObj["de"] != undefined)
                    region = langObj["de"];
                else
                    region = "";
            }
        }
        return region;
    }
    static set(region) {
        var _a;
        if (region != "") {
            zfcsr.selectedRegion = region;
            if ("localStorage" in window)
                localStorage.setItem("zfcsr-selected-region", region);
            var htmlLang = ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang) || "en";
            if (!zfUtils.isPreview)
                if (zfcsr.regions[region].hasOwnProperty("exclude") &&
                    zfcsr.regions[region].exclude[htmlLang] !=
                        undefined &&
                    $(".zfch2-language-dropdown .zfch2-link-item[data-value=en]").length)
                    $(".zfch2-language-dropdown .zfch2-link-item[data-value=en]").click();
            $("[data-region]").addClass("zfcsr-hide");
            $("[data-region*='" + region + "']").removeClass("zfcsr-hide");
        }
    }
    static registerCallback(selector, func) {
        zfcsr.updateCallbacks[selector] = func;
    }
    static setCallback(region) {
        zfcsr.set(region);
        zfcsr.init();
    }
    static getSortedKeys() {
        return Object.keys(zfcsr.regions).sort(function compareRegions(e1, e2) {
            if (zfcsr.get(e1).toLowerCase() < zfcsr.get(e2).toLowerCase())
                return -1;
            else if (zfcsr.get(e1).toLowerCase() > zfcsr.get(e2).toLowerCase())
                return 1;
            return 0;
        });
    }
    static isPageAvailableInRegion(region) {
        var _a;
        if (!region)
            return false;
        var url = window.location.href;
        if (url.match(new RegExp("/(cv_)?(emea|americas|ind|apac)/"))) {
            return ($('meta[name="zf_regions"]').attr("content") || "").includes(region);
        }
        else if (localStorage.preferredLang &&
            document.querySelector('link[hreflang="' +
                zfcsr.selectorAttributeValue(localStorage.preferredLang) +
                '"][region*="' +
                zfcsr.selectorAttributeValue(region) +
                '"]') != null)
            return true;
        else if (url.indexOf("products_") == -1 &&
            $('[data-region*="' + region + '"]').filter(function () {
                return ($(this).closest(".zfch2-header2").length == 0 &&
                    $(this).closest(".zfcf-footer").length == 0);
            }).length)
            return true;
        else {
            var lang = ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.getAttribute("lang")) || "en";
            if ((!zfcsr.regions[region].hasOwnProperty("exclude") ||
                !(lang in zfcsr.regions[region].exclude)) &&
                document.querySelector("link[hreflang=" + lang + "]:not(link[region])") != null)
                return true;
        }
        return false;
    }
    static getRegionAvailabilityMap() {
        var availabilityMap = {};
        zfcsr.getSortedKeys().forEach(function (region) {
            availabilityMap[region] = zfcsr.isPageAvailableInRegion(region);
        });
        return availabilityMap;
    }
    static isDisabled() {
        if (window.location.search.indexOf("disableRegion=true") != -1)
            return true;
        return ("localStorage" in window &&
            localStorage.getItem("zfDisableRegion") == "true");
    }
    static scheduleRegionDialog(availabilityMap) {
        if (zfcsr.isDisabled())
            return;
        if (zfcsr.regionDialogScheduled)
            return;
        zfcsr.regionDialogScheduled = true;
        zfUtils.scheduleOnFirstInteraction("region-dialog", function () {
            zfcsr.regionDialogScheduled = false;
            zfcsr.initRegionDialog(availabilityMap);
        }, ["scroll", "click", "touchstart", "mousemove", "keydown"], 5000);
    }
    static initRegionDialog(availabilityMap) {
        var popupCode = "";
        if ($(".zfcsr-select-region").length == 0)
            popupCode =
                `<div class="zfcsr-select-region">
							<div class="zfcsr-filter"></div>
							<div class="zfcsr-choice">
							  <p class="zfcsr-header">` +
                    zfTranslations.get("select_region.header") +
                    `</p>
							  <p class="zfcsr-text">` +
                    zfTranslations.get("select_region.text") +
                    `</p>`;
        var regionsNotAvailable = false;
        zfcsr.getSortedKeys().forEach(function (region) {
            popupCode = popupCode + `<button class="zfcsr-button `;
            var isAvailable = availabilityMap && availabilityMap.hasOwnProperty(region)
                ? availabilityMap[region]
                : zfcsr.isPageAvailableInRegion(region);
            if (!isAvailable) {
                popupCode = popupCode + "zfcsr-gray";
                regionsNotAvailable = true;
            }
            popupCode =
                popupCode +
                    `" value="` +
                    region +
                    `">` +
                    zfcsr.get(region) +
                    `</button>`;
        });
        if (regionsNotAvailable)
            popupCode =
                popupCode +
                    `<p class="zfcsr-text zfcui-color-red">` +
                    zfTranslations.get("select_region.not_available") +
                    `</p>`;
        popupCode =
            popupCode +
                `</div>
						  </div>`;
        if (popupCode != "") {
            $("body").append(popupCode);
        }
        $(".zfcsr-select-region").show();
        $(".zfcsr-button")
            .off("click.zfcsr")
            .on("click.zfcsr", function () {
            var region = $(this).attr("value") || "";
            zfcsr.set(region);
            if ($(this).hasClass("zfcsr-gray") && region != "")
                window.location.href = ($(".zfch2-header2-logo a").attr("href") || "")
                    .replace(new RegExp("/cv_(emea|americas|ind|apac)/"), "/cv_" + region.toLowerCase() + "/")
                    .replace(new RegExp("/(emea|americas|ind|apac)/"), "/" + region.toLowerCase() + "/");
            zfcsr.setCallback(region);
            zfcsr.hideRegionSelect();
            zfcsr.initRegionDropdown();
        });
    }
    static initRegionDropdown(availabilityMap) {
        var items = [];
        zfcsr.getSortedKeys().forEach(function (region) {
            var active = zfcsr.selectedRegion == region ? true : false;
            var disabled = availabilityMap && availabilityMap.hasOwnProperty(region)
                ? !availabilityMap[region]
                : !zfcsr.isPageAvailableInRegion(region);
            items.push({
                key: region,
                value: zfcsr.get(region),
                active: active,
                disabled: disabled,
            });
        });
        $(".zfcsr-region-menu").remove();
        zfUtils.createDropdown("zfcsr-region-menu", "zfcsr-region-menu", zfTranslations.get("select_region.regions"), zfcsr.get(zfcsr.selectedRegion), items, zfcsr.setCallback);
    }
    static hideRegionSelect() {
        $(".zfcsr-select-region").hide();
    }
    static scrollToURLAnchorNav(e) {
        if (window.location.href.includes("?pageLink=")) {
            var splitUrl = window.location.href.split("?pageLink=");
            var anchorElm = document.getElementById(splitUrl[1]);
            var checkElm = window.location.href.indexOf("customers.zf.com") > 0
                ? (anchorElm === null || anchorElm === void 0 ? void 0 : anchorElm.nextElementSibling) || null
                : anchorElm;
            if (!checkElm)
                return;
            var offset = $(checkElm).offset();
            if (!offset)
                return;
            var elementTop = offset.top;
            var headerWrapper = $(".zfch2-header2").height() || 0;
            var viewportTop = ($(window).scrollTop() || 0) + ($(".zfch2-header2").height() || 0);
            if (elementTop < viewportTop || elementTop > viewportTop + 50) {
                window.scrollTo({ top: elementTop - headerWrapper });
            }
            if ((e.clientX == 0 && e.clientY == 0) || e == true) {
                $("a, button").each(function () {
                    if (zfUtils.inViewport($(this))) {
                        $(this).focus();
                        return false;
                    }
                });
            }
        }
    }
    static init() {
        var _a;
        try {
            if (zfcsr.enabled == true) {
                $(".zfch2-language-dropdown [data-value]").each(function (index, item) {
                    var itemLink = $('link[rel="alternate"][href="' + $(item).data("value") + '"]');
                    var regionsToInclude = itemLink.attr("region") != undefined
                        ? itemLink.attr("region") || ""
                        : Object.keys(zfcsr.regions).join(",");
                    var hrefLang = itemLink.attr("hreflang");
                    Object.keys(zfcsr.regions).forEach(function (region) {
                        if (zfcsr.regions[region].hasOwnProperty("exclude") &&
                            hrefLang != undefined &&
                            zfcsr.regions[region].exclude[hrefLang])
                            regionsToInclude = regionsToInclude.replace(region, "");
                    });
                    $(item).attr("data-region", regionsToInclude);
                });
                if ("localStorage" in window &&
                    localStorage.getItem("zfcsr-selected-region")) {
                    if (localStorage.getItem("zfcsr-selected-region") == "WNA")
                        localStorage.setItem("zfcsr-selected-region", "AMERICAS");
                    zfcsr.set(localStorage.getItem("zfcsr-selected-region") || "");
                }
                else if (zfUtils.urlParams.has("zf_region")) {
                    zfcsr.set(zfUtils.urlParams.get("zf_region") || "");
                }
                var availabilityMap = zfcsr.getRegionAvailabilityMap();
                var selectedRegionAvailable = zfcsr.selectedRegion != "" &&
                    (availabilityMap.hasOwnProperty(zfcsr.selectedRegion)
                        ? availabilityMap[zfcsr.selectedRegion]
                        : zfcsr.isPageAvailableInRegion(zfcsr.selectedRegion));
                var selectedRegionLink = zfcsr.selectedRegion != ""
                    ? document.querySelector('link[region="' +
                        zfcsr.selectorAttributeValue(zfcsr.selectedRegion) +
                        '"]')
                    : null;
                var url = (selectedRegionLink === null || selectedRegionLink === void 0 ? void 0 : selectedRegionLink.getAttribute("href")) || "";
                if (url !== "") {
                    if (!zfcsr.isDisabled() && selectedRegionAvailable && window.location.href !== url && ((selectedRegionLink === null || selectedRegionLink === void 0 ? void 0 : selectedRegionLink.getAttribute("hrefLang")) == localStorage.preferredLang)) {
                        window.location.href = url;
                    }
                    else
                        zfcsr.initRegionDropdown(availabilityMap);
                }
                else {
                    url = ((_a = document.querySelector("link[hreflang]")) === null || _a === void 0 ? void 0 : _a.getAttribute("href")) || "";
                }
                if (zfcsr.isDisabled()) {
                    zfcsr.initRegionDropdown(availabilityMap);
                }
                else if (zfcsr.selectedRegion == "") {
                    zfcsr.scheduleRegionDialog(availabilityMap);
                }
                else if (!zfUtils.isPreview && !selectedRegionAvailable)
                    zfcsr.scheduleRegionDialog(availabilityMap);
                else if (selectedRegionAvailable &&
                    url.match(new RegExp("/(emea|americas|ind|apac)/"))) {
                    if (!url.includes("/" + this.selectedRegion.toLowerCase() + "/")) {
                        window.location.href = url.replace(new RegExp("/(emea|americas|ind|apac)/"), "/" + this.selectedRegion.toLowerCase() + "/");
                    }
                    else
                        zfcsr.initRegionDropdown(availabilityMap);
                }
                else
                    zfcsr.initRegionDropdown(availabilityMap);
            }
            else if (zfcsr.enabled == false && !("localStorage" in window)) {
                $("[data-region]").show();
            }
            var sim = true;
            zfcsr.scrollToURLAnchorNav(sim);
        }
        catch (err) {
            console.log("Initalization failed: zfcsr.init() " + err.message);
        }
    }
}
zfcsr.selectedRegion = "";
zfcsr.enabled = false;
zfcsr.regionDialogScheduled = false;
zfcsr.updateCallbacks = {};
export class zfUtils {
    Utils() {
        zfUtils.all = zfTranslations.get("all");
    }
    static handlebarsCompile(inputHtml) {
        return Handlebars.compile(inputHtml);
    }
    static handlebarsProcessTemplate(template, data) {
        return template(data, { allowProtoPropertiesByDefault: true }).replace('href=""', "");
    }
    static init() {
        try {
            Handlebars.registerHelper("decodeHtml", function (value) {
                return zfUtils.decodeHtml(value);
            });
            Handlebars.registerHelper("trans", function (key) {
                return zfTranslations.get(key);
            });
            Handlebars.registerHelper("canonical", function (key) {
                return $('link[rel="canonical"]').attr("href");
            });
            Handlebars.registerHelper("ogdescription", function (key) {
                return $('meta[property="og:description"]').attr("content");
            });
            Handlebars.registerHelper("dateLocale", function (field) {
                var _a;
                var lang = ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang.toLowerCase()) || "en";
                field = new Date(field)
                    .toLocaleDateString(lang)
                    .replace(/\//g, "-")
                    .replace(/\./g, "-");
                return field;
            });
            Handlebars.registerHelper("replaceLast", function (find, replace, options) {
                var myString = options.fn(this);
                return zfUtils.replaceLast(find, replace, myString);
            });
            Handlebars.registerHelper("ifCond", function (v1, operator, v2, options) {
                if (typeof v1 == "string")
                    v1 = v1.toLowerCase();
                if (typeof v2 == "string")
                    v2 = v2.toLowerCase();
                switch (operator) {
                    case "==":
                        return v1 == v2 ? options.fn(this) : options.inverse(this);
                    case "===":
                        return v1 === v2 ? options.fn(this) : options.inverse(this);
                    case "!=":
                        return v1 != v2 ? options.fn(this) : options.inverse(this);
                    case "!==":
                        return v1 !== v2 ? options.fn(this) : options.inverse(this);
                    case "<":
                        return v1 < v2 ? options.fn(this) : options.inverse(this);
                    case "<=":
                        return v1 <= v2 ? options.fn(this) : options.inverse(this);
                    case ">":
                        return v1 > v2 ? options.fn(this) : options.inverse(this);
                    case ">=":
                        return v1 >= v2 ? options.fn(this) : options.inverse(this);
                    case "&&":
                        return v1 && v2 ? options.fn(this) : options.inverse(this);
                    case "||":
                        return v1 || v2 ? options.fn(this) : options.inverse(this);
                    case "%":
                        return v1 % parseInt(v2) == 0
                            ? options.fn(this)
                            : options.inverse(this);
                    case "!%":
                        return v1 % parseInt(v2) != 0
                            ? options.fn(this)
                            : options.inverse(this);
                    case "has":
                        return v1.hasOwnProperty(v2)
                            ? options.fn(this)
                            : options.inverse(this);
                    case "!has":
                        return !v1.hasOwnProperty(v2)
                            ? options.fn(this)
                            : options.inverse(this);
                    case "includes":
                        return v1.includes(v2) ? options.fn(this) : options.inverse(this);
                    case "!includes":
                        return !v1.includes(v2)
                            ? options.fn(this)
                            : options.inverse(this);
                    default:
                        return options.inverse(this);
                }
            });
            zfUtils.initUrlParams();
            if (!("ontouchstart" in document.documentElement)) {
                document.documentElement.className += " no-touch";
            }
            if (window.location.search.indexOf("disableALS=true") != -1)
                $("#complete #head a.list-group-item").each(function (index, item) {
                    $(item).attr("href", $(item).attr("href") + "&disableALS=true");
                });
            if (zfUtils.loadOnScrollRegistrationKey === null) {
                zfUtils.loadOnScrollRegistrationKey = zfUtils.onScroll(zfUtils.checkLoadOnScroll);
            }
            $(window)
                .off("hashchange.zfutils")
                .on("hashchange.zfutils", zfUtils.onHashChange);
            zfUtils.onHashChange();
        }
        catch (err) {
            console.log("Initalization failed: zfUtils.init()  " + err.message);
        }
    }
    static initUrlParams() {
        var parameters = document.URL.split("?")[1];
        var hash;
        if (parameters != undefined) {
            var q = parameters.split("&");
            for (var i = 0; i < q.length; i++) {
                hash = q[i].split("=");
                zfUtils.urlParams.set(hash[0], hash[1]);
            }
        }
    }
    static arrayHasValue(arr, value, field) {
        for (var i = 0; i < arr.length; i++) {
            if ((field != undefined ? arr[i][field] : arr[i]) == value)
                return true;
        }
        return false;
    }
    static arrayRemoveDuplicates(arr) {
        return arr.reduce(function (a, b) {
            if (a.indexOf(b) < 0)
                a.push(b);
            return a;
        }, []);
    }
    static sortByKey(arr, key, order, otherKey) {
        return arr.sort(function (a, b) {
            var x = "";
            var y = "";
            if (otherKey != undefined) {
                x = a[key][otherKey].toString().toLowerCase();
                y = b[key][otherKey].toString().toLowerCase();
            }
            else {
                x = a[key].toString().toLowerCase();
                y = b[key].toString().toLowerCase();
            }
            if (order == "desc")
                return x > y ? -1 : x < y ? 1 : 0;
            else
                return x < y ? -1 : x > y ? 1 : 0;
        });
    }
    static filterByKey(arr, fields, values) {
        return arr.filter(function (a) {
            var result = true;
            if (typeof fields === "string" && fields == "ANY")
                return (JSON.stringify(a).toLowerCase().indexOf(values.toLowerCase()) != -1);
            else if (result == true)
                fields.forEach(function (field) {
                    if (result == true && values.hasOwnProperty(field.id)) {
                        var fieldResult = false;
                        values[field.id].forEach(function (value) {
                            if (value.length > 0 &&
                                a[field.id] != undefined &&
                                a[field.id].toString().indexOf(value) != -1)
                                fieldResult = true;
                        });
                        if (values[field.id].length > 0)
                            result = fieldResult;
                    }
                });
            return result;
        });
    }
    static inViewport(el) {
        var that = $(el);
        var offset = that.offset();
        if (!offset)
            return false;
        var elementTop = Math.ceil(offset.top);
        var elementBottom = elementTop + (that.height() || 0);
        var viewportTop = ($(window).scrollTop() || 0) + ($(".zfch2-header2").height() || 0);
        var viewportBottom = ($(window).scrollTop() || 0) + ($(window).height() || 0);
        return ((elementTop >= viewportTop && elementBottom <= viewportBottom) ||
            ((that.height() || 0) > viewportBottom - viewportTop &&
                elementTop <= viewportTop));
    }
    static replaceLast(find, replace, myString) {
        if (myString == undefined)
            return "";
        var endStr = myString.split(find)[myString.split(find).length - 1];
        return myString.replace(find + endStr, replace + endStr);
    }
    static getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        var result = "";
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                result = c.substring(name.length, c.length);
            }
        }
        return result;
    }
    static setCookie(name, value, days) {
        var d = "";
        if (days) {
            var e = new Date();
            e.setTime(e.getTime() + 24 * days * 60 * 60 * 1e3);
            d = "; expires=" + e.toUTCString();
        }
        document.cookie = name + "=" + value + d + "; path=/";
    }
    static isCookieTypeAllowed(cookieType) {
        if (window.location.search.indexOf("disableCookieCheck=true") != -1)
            return true;
        else if (cookieType == "Strictly Necessary")
            return true;
        else if (zfUtils.getCookie("OptanonConsent") != "") {
            var group = "";
            if (cookieType == "Performance")
                group = "C0002:1";
            else if (cookieType == "Functional")
                group = "C0003:1";
            else if (cookieType == "Targeting")
                group = "C0004:1";
            if (window.hasOwnProperty("OptanonActiveGroups")) {
                if (window.OptanonActiveGroups.indexOf(group.split(":")[0]) != -1)
                    return true;
                else
                    return false;
            }
            else if (zfUtils.getCookie("OptanonConsent").indexOf(group) != -1)
                return true;
        }
        return false;
    }
    static initPiwik(window, document, script, dataLayerName, id) {
        try {
            if (zfUtils.piwikScriptRequested)
                return;
            zfUtils.piwikScriptRequested = true;
            (window[dataLayerName] = window[dataLayerName] || []),
                window[dataLayerName].push({
                    start: new Date().getTime(),
                    event: "stg.start",
                });
            var scripts = document.getElementsByTagName("script")[0], tags = document.createElement("script");
            var isStgDebug = (window.location.href.match("stg_debug") ||
                document.cookie.match("stg_debug")) &&
                !window.location.href.match("stg_disable_debug");
            if (isStgDebug)
                zfUtils.setCookie("stg_debug", 1, 14);
            var qP = [];
            dataLayerName !== "dataLayer" &&
                qP.push("data_layer_name=" + dataLayerName),
                isStgDebug && qP.push("stg_debug");
            var qPString = qP.length > 0 ? "?" + qP.join("&") : "";
            (tags.defer = true),
                (tags.async = true),
                (tags.src =
                    "//zf-friedrichshafen.containers.piwik.pro/" + id + ".js" + qPString);
            if (scripts.parentNode) {
                scripts.parentNode.insertBefore(tags, scripts);
            }
            const ppms = {
                tm: {},
                cm: {},
            };
            for (let i = 0; i < ["tm", "cm"].length; i++) {
                (function (i) {
                    let ppms = {};
                    ppms[i] = ppms[i] || {};
                    ppms[i].api =
                        ppms[i].api ||
                            function () {
                                const args = [].slice.call(arguments, 0);
                                if (typeof args[0] === "string") {
                                    window[dataLayerName].push({
                                        event: "ppms." + i + ":" + args[0],
                                        parameters: [].slice.call(arguments, 1),
                                    });
                                }
                            };
                })(["tm", "cm"][i]);
            }
        }
        catch (err) {
            console.log("Initalization failed: zfUtils.initPiwik()  " + err.message);
        }
    }
    static initOnetrust(onetrustId) {
        if (zfUtils.oneTrustScriptRequested)
            return;
        zfUtils.oneTrustScriptRequested = true;
        var scripts = document.getElementsByTagName("script")[0], tags = document.createElement("script");
        tags.async = true;
        tags.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
        tags.type = "text/javascript";
        tags.charset = "UTF-8";
        tags.setAttribute("data-domain-script", onetrustId);
        if (scripts.parentNode) {
            scripts.parentNode.insertBefore(tags, scripts);
        }
        globalThis.OptanonWrapper = function () {
            zfUtils.onOneTrustLoaded();
        };
    }
    static initSiteimprove() {
        if (zfUtils.siteimproveScriptRequested)
            return;
        zfUtils.siteimproveScriptRequested = true;
        var scripts = document.getElementsByTagName("script")[0], tags = document.createElement("script");
        tags.async = true;
        tags.src = "https://siteimproveanalytics.com/js/siteanalyze_1926.js";
        if (scripts.parentNode) {
            scripts.parentNode.insertBefore(tags, scripts);
        }
    }
    static scheduleOnFirstInteraction(key, callback, eventNames, fallbackDelay, useLoadFallback) {
        if (zfUtils.interactionBindings[key])
            return;
        var runCallback = function () {
            zfUtils.unbindInteractionTriggers(key, eventNames);
            callback();
        };
        zfUtils.interactionBindings[key] = true;
        zfUtils.interactionHandlers[key] = function () {
            runCallback();
        };
        eventNames.forEach(function (eventName) {
            window.addEventListener(eventName, zfUtils.interactionHandlers[key], {
                once: true,
                passive: true,
            });
        });
        if (fallbackDelay != undefined) {
            zfUtils.interactionFallbackTimers[key] = window.setTimeout(function () {
                runCallback();
            }, fallbackDelay);
        }
        if (useLoadFallback) {
            zfUtils.interactionLoadHandlers[key] = function () {
                runCallback();
            };
            window.addEventListener("load", zfUtils.interactionLoadHandlers[key], {
                once: true,
            });
        }
    }
    static unbindInteractionTriggers(key, eventNames) {
        var handler = zfUtils.interactionHandlers[key];
        if (handler) {
            eventNames.forEach(function (eventName) {
                window.removeEventListener(eventName, handler);
            });
            zfUtils.interactionHandlers[key] = null;
        }
        if (zfUtils.interactionLoadHandlers[key]) {
            window.removeEventListener("load", zfUtils.interactionLoadHandlers[key]);
            zfUtils.interactionLoadHandlers[key] = null;
        }
        if (zfUtils.interactionFallbackTimers[key] !== undefined && zfUtils.interactionFallbackTimers[key] !== null) {
            window.clearTimeout(zfUtils.interactionFallbackTimers[key]);
            zfUtils.interactionFallbackTimers[key] = null;
        }
        zfUtils.interactionBindings[key] = false;
    }
    static scheduleOnetrustInit(onetrustId) {
        if (!onetrustId || zfUtils.oneTrustScriptRequested)
            return;
        var loadOneTrust = function () {
            zfUtils.initOnetrust(onetrustId);
        };
        zfUtils.scheduleOnFirstInteraction("one-trust", function () {
            if (!zfUtils.oneTrustScriptRequested)
                loadOneTrust();
        }, ["scroll", "click", "touchstart", "mousemove", "keydown"], 5000);
    }
    static schedulePiwikInit(id) {
        if (!id || zfUtils.piwikScriptRequested)
            return;
        var loadPiwik = function () {
            zfUtils.initPiwik(window, document, "script", "dataLayer", id);
        };
        zfUtils.scheduleOnFirstInteraction("piwik", function () {
            if (!zfUtils.piwikScriptRequested)
                loadPiwik();
        }, ["scroll", "click", "touchstart", "mousemove", "keydown"], 5000);
    }
    static scheduleSiteimproveInit() {
        if (zfUtils.siteimproveScriptRequested)
            return;
        zfUtils.scheduleOnFirstInteraction("siteimprove", function () {
            if (!zfUtils.siteimproveScriptRequested)
                zfUtils.initSiteimprove();
        }, ["scroll", "click", "touchstart", "mousemove", "keydown"], 5000);
    }
    static decodeHtml(value) {
        return $("<div>").html(value).text();
    }
    static autoLangSwitch() {
        var _a;
        var botPattern = "(googlebot/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
        var re = new RegExp(botPattern, "i");
        if (window.location.host.indexOf("cms05") != -1 ||
            window.location.search.indexOf("disableALS=true") != -1 ||
            localStorage.getItem("zfDisableALS") == "true" ||
            re.test(navigator.userAgent)) {
            console.log("Skip ALS");
            return;
        }
        if (localStorage.getItem("preferredLang") == null) {
            console.log("detecting browser language");
            var language = (navigator.languages && navigator.languages[0]) ||
                navigator.language ||
                navigator.language;
            language = language.replace("-", "_").toLowerCase();
            var languageWithoutLocale = language.split("_")[0];
            localStorage.setItem("preferredLang", languageWithoutLocale);
        }
        var preferredLanguage = localStorage.getItem("preferredLang");
        if (preferredLanguage != null) {
            var alternativeTag = null;
            if (zfcsr.enabled &&
                zfcsr.selectedRegion.length &&
                document.querySelector("link[region]") != null) {
                if (zfcsr.regions[zfcsr.selectedRegion].hasOwnProperty("exclude") &&
                    zfcsr.regions[zfcsr.selectedRegion].exclude.hasOwnProperty(preferredLanguage))
                    preferredLanguage = "en";
                alternativeTag = document.querySelector("link[hreflang=" +
                    preferredLanguage +
                    "][region*=" +
                    zfcsr.selectedRegion +
                    "]");
                if (alternativeTag == undefined)
                    alternativeTag = document.querySelector("link[hreflang=" + preferredLanguage + "]:not(link[region])");
            }
            else if (document.querySelector("link[hreflang][region]") == null)
                alternativeTag = document.querySelector("link[hreflang=" + preferredLanguage + "]");
            if (!alternativeTag)
                return;
            var htmlLang = ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang) || "en";
            var alternativeHref = alternativeTag.getAttribute("href") || "";
            if (preferredLanguage != htmlLang &&
                location.href.indexOf(alternativeHref) == -1) {
                window.location.href =
                    alternativeHref +
                        window.location.search +
                        window.location.hash;
            }
            else if (zfcsr.enabled &&
                zfcsr.selectedRegion.length &&
                location.href.indexOf(alternativeHref) == -1) {
                window.location.href =
                    alternativeHref +
                        window.location.search +
                        window.location.hash;
            }
        }
    }
    static isOnScreen(item, pageCount) {
        if (pageCount == undefined)
            pageCount = 1;
        var currItem = item;
        while (currItem[0] != document.body && currItem.offset().top == 0) {
            currItem = $(currItem.parent());
        }
        return (currItem.offset().top <=
            ($(window).scrollTop() || 0) + (($(window).height() || 0) * pageCount));
    }
    static loadOnScroll(item, name, callback, pageCount) {
        if (pageCount == undefined)
            pageCount = 1;
        var initialized = false;
        if (zfUtils.isOnScreen(item, 1))
            initialized = callback(item);
        if (!initialized) {
            if (!zfUtils.loadOnScrollList.has(name)) {
                zfUtils.loadOnScrollList.set(name, {
                    callback: callback,
                    pageCount: pageCount,
                });
            }
            item.addClass(name);
        }
    }
    static checkLoadOnScroll() {
        zfUtils.loadOnScrollList.forEach((value, key) => {
            $("." + key).each(function () {
                if (zfUtils.isOnScreen($(this))) {
                    if (value.callback($(this)))
                        $(this).removeClass(key);
                }
                else
                    return false;
            });
        });
    }
    static onHashChange() {
        if (window.location.hash != "" &&
            window.location.hash != "#" &&
            window.location.hash.indexOf("#session_state") == -1 &&
            window.location.hash.indexOf("/") == -1 &&
            $(window.location.hash).length > 0) {
            var hashOffset = $(window.location.hash).offset();
            if (!hashOffset)
                return;
            $("html, body").animate({
                scrollTop: hashOffset.top - ($(".zfch2-header2").height() || 0),
            });
        }
    }
    static onOneTrustLoaded() {
        $(".ot-cookies-td-content").each(function (i, el) {
            var oneTrustNewString = "";
            $(el)
                .text()
                .split(",")
                .forEach(function (item) {
                if (item.indexOf("_pk_id") != -1) {
                    if (oneTrustNewString.indexOf("_pk_id") == -1)
                        oneTrustNewString = oneTrustNewString + ",_pk_id.*";
                }
                else if (item.indexOf("_pk_ses") != -1) {
                    if (oneTrustNewString.indexOf("_pk_ses") == -1)
                        oneTrustNewString = oneTrustNewString + ", _pk_ses.*";
                }
                else if (item.indexOf("ppms_privacy_") != -1) {
                    if (oneTrustNewString.indexOf("ppms_privacy_") == -1)
                        oneTrustNewString = oneTrustNewString + ", ppms_privacy_*";
                }
                else {
                    oneTrustNewString = oneTrustNewString + ", " + item;
                }
            });
            if (oneTrustNewString.length > 0)
                oneTrustNewString = oneTrustNewString.substring(1, oneTrustNewString.length);
            $(el).text(oneTrustNewString);
        });
        if (zfUtils.oneTrust.initialized) {
            var isChanged = false;
            if (zfUtils.oneTrust.allowPerformance !=
                zfUtils.isCookieTypeAllowed("Performance"))
                isChanged = true;
            else if (zfUtils.oneTrust.allowFunctional !=
                zfUtils.isCookieTypeAllowed("Functional"))
                isChanged = true;
            else if (zfUtils.oneTrust.allowTargeting !=
                zfUtils.isCookieTypeAllowed("Targeting"))
                isChanged = true;
            if (isChanged)
                location.reload();
            else
                zfcsr.init();
        }
        else {
            zfUtils.oneTrust.allowPerformance =
                zfUtils.isCookieTypeAllowed("Performance");
            zfUtils.oneTrust.allowFunctional =
                zfUtils.isCookieTypeAllowed("Functional");
            zfUtils.oneTrust.allowTargeting =
                zfUtils.isCookieTypeAllowed("Targeting");
            zfUtils.oneTrust.initialized = true;
        }
    }
    static displaySpinner() {
        zfUtils.spinner = $(".zfcui-loading");
        if (zfUtils.spinner.length == 0) {
            $(".body-wrapper").append('<div class="zfcui-loading"><div class="zfcui-spinner"><span></span><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div class="zfcui-loading-bar-container" style="background-color: transparent;"><div class="zfcui-loading-bar-progress"></div></div></div>');
            zfUtils.spinner = $(".zfcui-loading");
        }
        zfUtils.spinner.show();
        zfUtils.spinnerShowCount++;
    }
    static hideSpinner() {
        zfUtils.spinnerShowCount--;
        zfUtils.spinner = $(".zfcui-loading");
        if (zfUtils.spinnerShowCount == 0 && zfUtils.spinner.length == 1) {
            zfUtils.spinner.hide();
        }
    }
    static updateProgess(id, percentLoaded) {
        if ($(".zfcui-loading-bar-container").css("background-color") ==
            "rgba(0, 0, 0, 0)") {
            $(".zfcui-loading-bar-container").css("background-color", "var(--custom-gray-200)");
        }
        zfUtils.progressTracker[id] = { id: id, percentLoaded: percentLoaded };
        var sumAmountLoaded = 0;
        Object.keys(zfUtils.progressTracker).forEach(function (key) {
            if (zfUtils.progressTracker[key].percentLoaded != null) {
                sumAmountLoaded =
                    sumAmountLoaded + zfUtils.progressTracker[key].percentLoaded;
            }
        });
        $(".zfcui-loading-bar-progress").css("width", (sumAmountLoaded / Object.keys(zfUtils.progressTracker).length) * 100 +
            "%");
        if (sumAmountLoaded / Object.keys(zfUtils.progressTracker).length >= 1) {
            zfUtils.progressTracker = {};
            $(".zfcui-loading-bar-progress").css("width", "0px");
            $(".zfcui-loading-bar-container").css("background-color", "transparent");
        }
    }
    static sliderCircleActiveSlide(el, useSwiper) {
        var that = $(el);
        var active = 0;
        if (useSwiper) {
            that.find(".swiper-pagination-bullet").each(function (index, item) {
                active = active + 1;
                if ($(item).hasClass("swiper-pagination-bullet-active")) {
                    return false;
                }
            });
        }
        else {
            that.find(".custom-dots li").each(function (index, item) {
                active = active + 1;
                if ($(item).hasClass("slick-active")) {
                    return false;
                }
            });
        }
        return active;
    }
    static sliderCircleProgress(el, circleClass, textClass, useSwiper) {
        var that = $(el);
        var total = that.find(".zfccs-stage-item:not(.slick-cloned)").length;
        var active = 0;
        var classString = "zfc-circle-animation-" + that.attr("id");
        active = zfUtils.sliderCircleActiveSlide(that, useSwiper);
        if (that.data("autoplay") == true) {
            var speed = that.data("speed") / 1000 + "s";
            var circle = that.find(circleClass);
            circle.css("animation-duration") != speed
                ? circle.css("animation-duration", speed)
                : null;
        }
        else if (that.data("autoplay") == false) {
            that
                .find(circleClass)
                .css("stroke-dashoffset", 19 * 2 * 3.14 - (((100 / total) * active) / 100) * 19 * 2 * 3.14);
        }
        var txt = active + "/" + total;
        that.find(textClass).empty();
        that.find(textClass).append(txt);
    }
    static registerOn(target, cb, key, unattachEvent) {
        target[key] = cb;
        return key;
    }
    static unregisterOn(target, key) {
        if (target && Object.prototype.hasOwnProperty.call(target, key)) {
            delete target[key];
        }
    }
    static offReady(key) {
        zfUtils.unregisterOn(zfUtils.readyRegistered, key);
    }
    static offScroll(key, direction) {
        if (direction && zfUtils.scrollRegistered.hasOwnProperty(direction)) {
            zfUtils.unregisterOn(zfUtils.scrollRegistered[direction], key);
            return;
        }
        Object.keys(zfUtils.scrollRegistered).forEach(function (dir) {
            zfUtils.unregisterOn(zfUtils.scrollRegistered[dir], key);
        });
    }
    static offResize(key) {
        Object.keys(zfUtils.resizeRegistered).forEach(function (dir) {
            zfUtils.unregisterOn(zfUtils.resizeRegistered[dir], key);
        });
    }
    static onReady(cb) {
        if (zfUtils.windowReady) {
            setTimeout(function () {
                cb();
            }, 0);
            return null;
        }
        else {
            const registrationKey = zfUtils.registerKey;
            zfUtils.registerOn(zfUtils.readyRegistered, cb, registrationKey, "Ready");
            zfUtils.registerKey++;
            return registrationKey;
        }
    }
    static onScroll(args) {
        let registrationKey = null;
        if (typeof args === "function") {
            registrationKey = zfUtils.registerKey;
            zfUtils.registerOn(zfUtils.scrollRegistered.all, args, registrationKey, "Scroll");
        }
        else if (args.direction && typeof args.callback === "function") {
            registrationKey = zfUtils.registerKey;
            zfUtils.registerOn(zfUtils.scrollRegistered[args.direction], args.callback, registrationKey, "Scroll");
        }
        if (registrationKey !== null) {
            zfUtils.registerKey++;
        }
        return registrationKey;
    }
    static onResize(args) {
        const registrationKey = zfUtils.registerKey;
        zfUtils.registerOn(zfUtils.resizeRegistered.all, args, registrationKey, "Resize");
        zfUtils.registerKey++;
        return registrationKey;
    }
    static invokeCallbackList(callbacks, event) {
        Object.keys(callbacks).forEach(function (key) {
            const cb = callbacks[key];
            if (typeof cb === "function")
                cb(event);
        });
    }
    static flushReadyCallbacks(batchSize) {
        const size = batchSize || 5;
        const keys = Object.keys(zfUtils.readyRegistered);
        const runBatch = function (index) {
            const end = Math.min(index + size, keys.length);
            for (let i = index; i < end; i++) {
                const key = keys[i];
                const cb = zfUtils.readyRegistered[key];
                if (typeof cb === "function")
                    cb();
                zfUtils.unregisterOn(zfUtils.readyRegistered, parseInt(key, 10));
            }
            if (end < keys.length) {
                setTimeout(function () {
                    runBatch(end);
                }, 0);
            }
        };
        runBatch(0);
    }
    static processScroll(event) {
        zfUtils.currentTop = window.scrollY || document.documentElement.scrollTop;
        zfUtils.scrollTop = zfUtils.currentTop < zfUtils.lastScroll;
        zfUtils.lastScroll = zfUtils.currentTop;
        if (zfUtils.scrollTop) {
            zfUtils.invokeCallbackList(zfUtils.scrollRegistered.up, event);
        }
        else {
            zfUtils.invokeCallbackList(zfUtils.scrollRegistered.down, event);
        }
        zfUtils.invokeCallbackList(zfUtils.scrollRegistered.all, event);
        window.clearTimeout(zfUtils.window.isScrolling);
        zfUtils.window.isScrolling = setTimeout(function () {
            zfUtils.invokeCallbackList(zfUtils.scrollRegistered.end, event);
        }, 66);
    }
    static processResize(event) {
        zfUtils.invokeCallbackList(zfUtils.resizeRegistered.all, event);
    }
    static createDropdown(id, className, label, activeValue, items, callback) {
        try {
            var headerDropdown = `
          <div class="zfcui-prometo-medium zfch2-header2-top-item zfch2-header2-top-text-item ` +
                className +
                `">
            <div class="zfch2-header2-top-item-menu zfcui-color-inherit">
              <button type="button" aria-controls="` +
                id +
                `" aria-haspopup="true" aria-expanded="false" class="zfch2-header2-top-item-menu-label">
                <div class="zfch2-header2-top-item-link-icon zfcui-icon zfcui-icon-arrow-big-thin-d"></div>      
                <div class="zfch2-dropdown-header">` +
                activeValue +
                `</div>
              </button>
              <div id="` +
                id +
                `" class="zfch2-header2-top-item-menu-dropdown">
                <div class="zfch2-header2-top-item-dropdown-item">
                  <div class="zfch2-link-item zfch2-link-headline zfc-bold">` +
                label +
                `</div>
                </div>
                <div class="zfch2-header2-border-bottom" role="separator"></div>`;
            items.forEach(function (item) {
                var classInfo = item.hasOwnProperty("disabled") && item.disabled ? " disabled" : "";
                classInfo =
                    classInfo +
                        (item.hasOwnProperty("active") && item.active ? " active" : "");
                if (item.hasOwnProperty("bold") && item.bold) {
                    classInfo = classInfo + " zfch2-link-headline zfc-bold";
                    headerDropdown +=
                        '<div class="zfch2-header2-border-bottom" role="separator"></div>';
                }
                headerDropdown += `<div class="zfch2-header2-top-item-dropdown-item">`;
                if (!item.hasOwnProperty("href"))
                    headerDropdown +=
                        `<button class="zfch2-link-item` +
                            classInfo +
                            `" data-value="` +
                            item.key +
                            `" role="menuitem">` +
                            item.value +
                            `</button>`;
                else
                    headerDropdown +=
                        `<a class=" zfch2-link-item` +
                            classInfo +
                            `" href="` +
                            item.href +
                            `" target="` +
                            (item.hasOwnProperty("target") && item.target != ""
                                ? item.target
                                : "_blank") +
                            `" aria-label="opens in a new tab" role="menuitem">` +
                            item.value +
                            `</a>
                       ` +
                            (item.hasOwnProperty("target") && item.target != "_self"
                                ? `<span class="zfcui-icon zfcui-icon-external-link level-2-anchor-icon"></span>`
                                : "");
                headerDropdown += `</div>`;
            });
            headerDropdown += `
              </div>
            </div>
          </div>`;
            $(".zfch2-header2-top-items-wrapper").append(headerDropdown);
            $("." + className + " .zfch2-link-item")
                .off("click.zfutils")
                .on("click.zfutils", function (e) {
                if ($(this).is("button") &&
                    !$(this).hasClass("disabled") &&
                    !$(this).hasClass("zfc-bold") &&
                    $(this).data("value") != "undefined") {
                    var selectedValue = $(this).data("value");
                    $("." + className + " .zfch2-dropdown-header").text($(this).text());
                    $("." + className + " .zfch2-link-item").removeClass("active");
                    $(this).addClass("active");
                    $(this)
                        .closest(".zfch2-header2-top-item-menu")
                        .removeClass("active");
                    window.history.replaceState({}, document.title, selectedValue);
                    callback(selectedValue);
                }
                e.stopPropagation();
            });
            $("." + className + " .zfch2-header2-top-item-menu")
                .off("click.zfutils")
                .on("click.zfutils", function (e) {
                var isActive = $(this).hasClass("active");
                $(".zfch2-header2-top-item-menu.active button").attr("aria-expanded", "false");
                $(".zfch2-header2-top-item-menu.active").removeClass("active");
                $("." + className + " .zfch2-header2-top-item-menu button").attr("aria-expanded", isActive ? "false" : "true");
                if (!isActive)
                    $(this).addClass("active");
                if ((($(window).outerWidth() || 0) >= zfUtils.desktopBreakpoint) &&
                    $(".burger-menu-opened").length)
                    $(".zfch2-header2-burger-menu").click();
                e.stopPropagation();
            });
        }
        catch (err) {
            console.log("initalization failed: zfUTils.createDropdown()\t" + err.message);
        }
    }
    static loadImg(img) {
        var $img = $(img);
        if ($img.data("width") && !$img.attr("width")) {
            $img.attr("width", $img.data("width"));
        }
        if ($img.data("height") && !$img.attr("height")) {
            $img.attr("height", $img.data("height"));
        }
        $img.attr("src", $img.data("src"));
        $img.removeAttr("data-src");
    }
}
zfUtils.urlParams = new Map();
zfUtils.loadOnScrollList = new Map();
zfUtils.spinnerShowCount = 0;
zfUtils.progressTracker = {};
zfUtils.oneTrust = {
    initialized: false,
    allowPerformance: false,
    allowFunctional: false,
    allowTargeting: false,
};
zfUtils.isPreview = false;
zfUtils.isWebedit = false;
zfUtils.document = $(document);
zfUtils.window = $(window);
zfUtils.currentTop = 0;
zfUtils.registerKey = 0;
zfUtils.loopKey = null;
zfUtils.loopKey2 = null;
zfUtils.desktopBreakpoint = 960;
zfUtils.lastScroll = 0;
zfUtils.scrollTop = false;
zfUtils.scrollRegistered = {
    up: [],
    down: [],
    end: [],
    all: [],
};
zfUtils.resizeRegistered = {
    ">": [],
    "<": [],
    all: [],
};
zfUtils.scrollRafPending = false;
zfUtils.resizeRafPending = false;
zfUtils.lastScrollEvent = null;
zfUtils.lastResizeEvent = null;
zfUtils.loadOnScrollRegistrationKey = null;
zfUtils.windowReady = false;
zfUtils.readyRegistered = {};
zfUtils.oneTrustScriptRequested = false;
zfUtils.piwikScriptRequested = false;
zfUtils.siteimproveScriptRequested = false;
zfUtils.interactionBindings = {};
zfUtils.interactionHandlers = {};
zfUtils.interactionFallbackTimers = {};
zfUtils.interactionLoadHandlers = {};
try {
    globalThis.zfUtils = zfUtils;
    globalThis.Handlebars = Handlebars;
    $.ajax({
        url: $("head").data("fs"),
        method: "GET",
    })
        .done(function (data) {
        zfTranslations.translations = data.translations;
        zfTranslations.languages = data.languages;
        zfUtils.isPreview = data.isPreview;
        zfUtils.isWebedit = data.isWebedit;
        zfcsr.regions = data.regions;
        zfUtils.autoLangSwitch();
        zfUtils.fsData = data;
        zfUtils.init();
        zfUtils.windowReady = true;
        zfUtils.onHashChange();
        zfUtils.lastScroll =
            window.scrollY || document.documentElement.scrollTop;
        globalThis.zfUtils = zfUtils;
        zfUtils.flushReadyCallbacks();
        globalThis.zfTranslations = zfTranslations;
        globalThis.zfcsr = zfcsr;
    })
        .fail(function (jqXHR, textStatus, errorThrown) {
        console.log("Failed to load fs.json: " + textStatus + " " + errorThrown);
    });
    window.addEventListener("scroll", function (event) {
        zfUtils.lastScrollEvent = event;
        if (zfUtils.scrollRafPending)
            return;
        zfUtils.scrollRafPending = true;
        window.requestAnimationFrame(function () {
            zfUtils.scrollRafPending = false;
            zfUtils.processScroll(zfUtils.lastScrollEvent);
        });
    }, { passive: true });
    window.addEventListener("resize", function (event) {
        zfUtils.lastResizeEvent = event;
        if (zfUtils.resizeRafPending)
            return;
        zfUtils.resizeRafPending = true;
        window.requestAnimationFrame(function () {
            zfUtils.resizeRafPending = false;
            zfUtils.processResize(zfUtils.lastResizeEvent);
        });
    });
}
catch (err) {
    console.log("Initalization failed: zfUtils  " + err.message);
}
